




















































































































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import WarehouseingReturnCheckResponse from '@/store/entities/back-warehouseingreturncheckresponse';
    import storeaddressInfo from '@/store/entities/back-storeaddress-list';
    import ReturnOrderProductInfo from '@/store/entities/back-stockreturnorder';
    import appconst from '@/lib/appconst';
    import QRcode from 'qrcodejs2'
    import VueClipboard from 'vue-clipboard2'
    import Enums from '../../../lib/enums';
    Vue.use(VueClipboard)

    class IntoAbroadStockReturns {
        returnNumber: string = "";
        storeId: number;
        userId: number;
        source: number;
        orderNumber: string;
        oldOrderId: number;
        cargoCategory: number;
        remark: number;
        //orderType: number;
        shelfCost: number;
        shelfPosition: string;
        deductionCycle: number;
        deductIntegral: number;
        beginDeductionTime: Date;
        returnProductInfoList: Array<ReturnOrderProductInfo>;
        platformType: number;
    }

    @Component({
        name: "intoabroadstockreturncheck",
    })
    export default class CreateintoReturnsModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        intoReturns: IntoAbroadStockReturns = new IntoAbroadStockReturns();
        model: storeaddressInfo = null;
        selectDate: string = "";
        userCode: string = "";
        source: number;

        sourcsStatus = Enums.ReturnOrderSource;
        site: number;
        siteStatus = Enums.SiteSType;
        cargoCategory: number;
        cargoCategoryStatus = Enums.CargoCategoryType;
        checkLoding = false;
        checkResult: WarehouseingReturnCheckResponse = null;
        storeaddressList: Array<storeaddressInfo> = [];
        returnProductInfoList: Array<ReturnOrderProductInfo> = [];
        confirmWarehousingRequse: Array<IntoAbroadStockReturns> = [];
        models: boolean = false;
        created() {
            this.getData();

        }
        async getData() {
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            })
            //var a = new storeaddressInfo();
            //a.id = null;
            //a.storeName = "全部";
            this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true && item.whetherLocal == false });
            /*this.storeaddressList.push(a);*/
            //this.storeId = this.storeaddressList[0].id;
            var data: any = this.$refs.inputshipment;
            data.focus();
        }


        async NumberClick(ev) {
            if (ev.code == "ArrowLeft") {
                this.checkExpress();
            }
        }
        async checkExpress() {
            var returnNumber = "";
            var returnNumber = this.intoReturns.returnNumber;
            if (!returnNumber && returnNumber.length == 0) {
                this.$Message.error('检查的退件订单不能为空。');
                return;
            }

            var data = { returnNumber: returnNumber };
            this.intoReturns.returnNumber = data.returnNumber;
            this.checkLoding = true;
            this.checkResult = await this.$store.dispatch({
                type: 'intoabroadstockreturncheck/comfirmDestroyOrder',
                data: data
            }).finally(() => {
                this.checkLoding = false;
            });
            if (this.checkResult.source != 2) {
                this.models = true;
            }
            this.userCode = this.checkResult.userCode;
            this.source = this.checkResult.source;
            this.site = this.checkResult.site;
            this.cargoCategory = this.checkResult.cargoCategory;
            this.returnProductInfoList = this.checkResult.productListInfo;
            if (this.checkResult.storeId > 0) {
                this.intoReturns.storeId = this.checkResult.storeId;
            } else {
                var _this = this;
                this.model = this.storeaddressList.filter(function (item) { return item.site == _this.checkResult.site })[0];
                this.intoReturns.storeId = this.model.id;
            }


        }
        async signFor() {

            this.save();
        }
        save() {
            (this.$refs.intoReturnsCreateForm as any).validate(async (valid: boolean) => {
                if (valid) {

                    if (!this.checkResult) {
                        this.$Modal.error({ title: "错误", content: "未检查退件订单信息，不允许入库！" });
                        return;
                    }
                    //if (!this.selectDate || this.selectDate.length == 0) {
                    //    this.$Modal.error({ title: "错误", content: "未选择入库时间，不允许入库" });
                    //    return;
                    //} 
                    else {
                        var anyDate: any = this.selectDate;
                        this.intoReturns.beginDeductionTime = anyDate;
                    }

                    this.intoReturns.orderNumber = this.checkResult.orderNumber;
                    this.intoReturns.oldOrderId = this.checkResult.oldOrderId;
                    this.intoReturns.source = this.checkResult.source;
                    this.intoReturns.userId = this.checkResult.userId;
                    this.intoReturns.cargoCategory = this.checkResult.cargoCategory;
                    this.intoReturns.returnProductInfoList = this.checkResult.productListInfo;
                    this.intoReturns.platformType = this.checkResult.platformType;
                    this.confirmWarehousingRequse = await this.$store.dispatch({
                        type: 'intoabroadstockreturncheck/confirmReturnWarehousing',
                        data: this.intoReturns
                    }).finally(() => {
                        this.checkLoding = false;
                        //location.reload();
                    });
                    this.$Message.success("退件入库成功");
                    this.clearData();
                    //if (this.confirmWarehousingRequse) {
                    //    location.reload();
                    //}
                }
            })
        }

        copyShipment() {
            if (!this.intoReturns.returnNumber || this.intoReturns.returnNumber.length < 0) {
                this.$Message.error('快递单号为空，不能复制。');
            }
            this.copyInfo(this.intoReturns.returnNumber);
        }

        copyInfo(data) {
            var _this = this;
            this.$copyText(data).then(function (e) {
                _this.$Message.success("复制成功");
            }, function (e) {
                _this.$Message.error("复制失败");
            });
        }




        @Watch('$route.params.JumpPage')
        JumpPageChange() {
            if (this.$route.params.JumpPage) {
                var data: any = document.querySelector('input[name="shipmentId"]');
                data.focus();
            }


        }

        clearData() {
            (this.$refs.intoReturnsCreateForm as any).resetFields();
            //this.$emit('input', false);
        }
        intoReturnsRule = {
            shelfPosition: [
                { required: true, message: '货架位置不能为空', trigger: 'blur' }
            ],
            shelfCost: [
                { required: true, message: '上架费不能为空', trigger: 'blur' }
            ],
            deductionCycle: [
                { required: true, message: '扣费周期不能为空', trigger: 'blur' }
            ],
            deductIntegral: [
                { required: true, message: '扣费金额不能为空', trigger: 'blur' }
            ],
        };

    }
